import React from "react";
import "./payCalculation.css";
import { calculateTalentNetPay } from "./utils";

const PayCalculation = ({permenantGig, taxTermRadio, amount, isPrivateGig }) => {
  // const skillGigPercentage = isPrivateGig || selectedGigDetailsPrivte ? 10 : 20;
  const skillGigPercentage = 10;
  const payrollCostPercentage = taxTermRadio === "W-2" ? 18 : taxTermRadio === "Corp-to-Corp" ? 5 : 18;
  const { skillGiggFee, payrollCost, netGrossPay, grossPay } =
    calculateTalentNetPay({
      amount,
      skillGigPercentage,
      payrollCostPercentage,
    });

  return (
    <div className="wrapper-div">
      {
        permenantGig !== "Permanent" ?
        <div className="grid-container">
        <div className="grid-container1 grid-first-item">
          <div className="grid-item1">SKILLGIGS PRICING TRANSPARENCY</div>
        </div>
        <div className="grid-container1">
          <div className="grid-item1">FINAL BILL RATE</div>
          <strong className="grid-item2">${amount}</strong>
        </div>
        <div className="grid-container1">
          <div className="grid-item1">SKILLGIGS FEES ({skillGigPercentage}%)</div>
          <div className="grid-item2">
            (${parseFloat(skillGiggFee).toFixed(2)})
          </div>
        </div>
        <div className="grid-container1">
          <div className="grid-item1">TALENT GROSS PAY</div>
          <strong className="grid-item2">
            ${parseFloat(grossPay).toFixed(2)}
          </strong>
        </div>
        <div className="grid-container1">
          <div className="grid-item1">PAYROLL COST TO TALENT ({payrollCostPercentage}%)</div>
          <div className="grid-item2">
            (${parseFloat(payrollCost).toFixed(2)})
          </div>
        </div>
        <div className="grid-container1 grid-last-item">
          <strong className="grid-item1">TALENT NET PAY</strong>
          <strong className="grid-item2">
            ${parseFloat(netGrossPay).toFixed(2)}
          </strong>
        </div>
      </div>
      : ""
      }
     
    </div>
  );
};

export default PayCalculation;
